import { defineStore } from 'pinia'
import { ref } from 'vue'
import { env } from '@/utils/env'

export const useConsentStore = defineStore('consent', () => {
  const categories = ref<string[]>([])

  function setCategories(newCategories: string[]) {
    categories.value = newCategories

    if (env.isDev) console.info('[ConsentStore] Updated categories:', newCategories)
  }

  return {
    categories,
    setCategories,
  }
})
